import { render, staticRenderFns } from "./specialInstitutionRegistration.vue?vue&type=template&id=717d4081"
import script from "./specialInstitutionRegistration.vue?vue&type=script&lang=js"
export * from "./specialInstitutionRegistration.vue?vue&type=script&lang=js"
import style0 from "./specialInstitutionRegistration.vue?vue&type=style&index=0&id=717d4081&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports